import type { SettingsOptionProps } from './Settings.types';
import type { ReactElement } from 'react';

import { Flex, Text } from '@rango-dev/whale';
import { Check } from 'lucide-react';
import React from 'react';

import styles from './Settings.module.css';

const CHECK_SIZE = 20;

export function SettingsOption(props: SettingsOptionProps): ReactElement {
  const { id, media, title, description, selected, onSelect } = props;

  return (
    <button
      type="button"
      id={id}
      className={styles.option}
      aria-pressed={selected}
      onClick={onSelect}>
      <Flex align="center" gap="3" flexGrow="1" minWidth="0">
        {media}
        <Flex direction="column" justify="center" flexGrow="1" minWidth="0">
          <Text size="2" weight="medium" truncate>
            {title}
          </Text>
          {description && (
            <Text size="2" color="gray" truncate>
              {description}
            </Text>
          )}
        </Flex>
      </Flex>
      {selected && <Check size={CHECK_SIZE} className={styles.optionCheck} />}
    </button>
  );
}
